import { render, staticRenderFns } from "./GroupReport.vue?vue&type=template&id=0b7947b8&scoped=true"
import script from "./GroupReport.vue?vue&type=script&lang=js"
export * from "./GroupReport.vue?vue&type=script&lang=js"
import style0 from "./GroupReport.vue?vue&type=style&index=0&id=0b7947b8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7947b8",
  null
  
)

export default component.exports